// ABOUTME: The interview card in the tracker's application detail, for the signed-in talent: the same card as the email
// ABOUTME: link, over /talent/interviews/{refId} with the Auth0 token.
import { useMemo } from 'react';
import { useAccessToken } from 'utils/auth';
import { createTalentInterviewApi } from '../client';
import { InterviewCard } from './InterviewCard';

/** @param layout `section` on the job page of an application: "Dein Interview" as a section of that page. */
export const TalentInterviewCard = ({
  refId,
  layout
}: {
  refId: string;
  layout?: 'card' | 'section';
}) => {
  const { token } = useAccessToken();
  const api = useMemo(() => createTalentInterviewApi(token), [token]);
  return <InterviewCard api={api} refId={refId} layout={layout} />;
};
